import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { InfoService } from 'src/app/services/info/info.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LoginService } from 'src/app/services/login/login.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-template',
  templateUrl: './login-template.component.html',
  styleUrls: ['./login-template.component.scss']
})
export class LoginTemplateComponent implements OnInit {

  public title = 'Bienvenue dans votre espace personnel&nbsp;!';
  public fullVersion = '';
  constructor(
    public router: Router,
    public infoService: InfoService,
    private authService: AuthService,
    private loginService: LoginService,
  ) {
    this.getTitle();
  }

  async ngOnInit(): Promise<void> {
    localStorage.setItem('openPatients', '[]');
    this.fullVersion = await this.getFullVersion();
  }

  get isLoggedIn(): boolean {
    return !!this.loginService.getCurrentUser();
  }

  public async logout(): Promise<void> {
    await this.authService.logoutSession();
    this.loginService.clearLocalSession();
    this.router.navigateByUrl('/');
  }

  public getVersion(): string {
    return environment.version + (environment.env !== "prod" ? "-" + environment.env : "");
  }

  public async getFullVersion(): Promise<string> {
    const informations = await this.infoService.getBackendInfos();
    return "Client: " + environment.version + "-" + environment.buildTimestamp + (environment.env !== "prod" ? "-" + environment.env : "") + "\n" +
      "API: " + informations.backVersion + "\n" +
      "DB: " + informations.hypermedDBVersion;
  }

  public getTitle(): void {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if ((val as NavigationEnd).url) {
          switch ((val as NavigationEnd).url) {
            case '/':
              this.title = 'Bienvenue dans votre espace personnel&nbsp;!';
              break;
            case '/forgot-password':
              this.title = 'Mot de passe oublié';
              break;
            case '/renew-password':
              this.title = 'Modifier votre mot de passe';
              break;
            case '/cps':
              this.title = 'Identification par carte CPS';
              break;
            default:
              this.title = 'Bienvenue dans votre espace personnel&nbsp;!';
              break;
          }
        }
      }
    });
  }

}
